import { render, staticRenderFns } from "./OTPLoginSuccess.vue?vue&type=template&id=2c046fb8&"
import script from "./OTPLoginSuccess.vue?vue&type=script&lang=ts&"
export * from "./OTPLoginSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports